module.exports = __webpack_public_path__ + "static/media/logo.923a286d.svg";